import React from "react";
import { DataGrid, esES } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import SnackbarAlert from "./SnackbarAlert";
import useToken from "../useToken";

class TablaPanelAuditorias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: useToken.getUser(),
      openSnack: false,
      message: null,
      severity: null,
      selectedRow: null,
      pageSize: 25
    };
  }

  render() {
    const columns = [
      { field: "folio", headerName: "Folio", flex: 1, minWidth: 100 },
      {
        field: "fecha",
        headerName: "Fecha",
        flex: 1,
        minWidth: 110,
        valueGetter: (params) =>
          params.row.fecha?.split("-").reverse().join("/")
      },
      {
        field: "cliente",
        headerName: "Cliente",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) =>
          params.row.cliente?.toUpperCase(),
      },
      { field: "tienda", headerName: "Tienda", flex: 1, minWidth: 150,
        renderCell: (params) => (
            <div style={{
            whiteSpace: "normal",
            lineHeight: "1.3"
            }}>
            {params.value}
            </div>
        )  
    },
      {
        field: "registros",
        headerName: "Registros",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },

      {
        field: "registros_auditados",
        headerName: "Reg.Auditados",
        flex: 1,
        minWidth: 135,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },

      {
        field: "avance",
        headerName: "Avance (%)",
        flex: 1.5,
        minWidth: 170,
        renderCell: (params) => {
            if (params.value == null) return null;

            const value = params.value * 100;

            let color = "error"; // rojo
            if (value === 100) color = "success";
            else if (value > 50) color = "warning";

            return (
            <div style={{ width: "100%" }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>
                {value.toFixed(2)}%
                </div>

                <LinearProgress
                variant="determinate"
                value={value}
                color={color}
                sx={{
                    height: 8,
                    borderRadius: 4
                }}
                />
            </div>
            );
        }
      },
      {
        field: "error",
        headerName: "Error Reg.(%)",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          `${(params.value * 100).toFixed(2)}%`
      },
      { field: "inicio_auditoria", headerName: "Inicio", flex: 1, minWidth: 150,
        renderCell: (params) => (
            <div style={{
            whiteSpace: "normal",
            lineHeight: "1.3"
            }}>
            {params.value}
            </div>
        ) 
      },
      { field: "ultima_validacion", headerName: "Última Val.", flex: 1, minWidth: 150,
          renderCell: (params) => (
              <div style={{
              whiteSpace: "normal",
              lineHeight: "1.3"
              }}>
              {params.value}
              </div>
          ) 
      },
      { field: "termino_auditoria", headerName: "Termino", flex: 1, minWidth: 150,
         renderCell: (params) => (
            <div style={{
            whiteSpace: "normal",
            lineHeight: "1.3"
            }}>
            {params.value}
            </div>
        ) 
      },
      {
        field: "abs_diferencia_importe",
        headerName: "Dif.Abs.Imp.(%)",
        flex: 1,
        minWidth: 160,
        renderCell: (params) => {
          const isHigh = params.value >= 5;

          return (
            <div
              style={{
                backgroundColor: isHigh ? "#ffebee" : "transparent",
                color: isHigh ? "#c62828" : "inherit",
                fontWeight: isHigh ? "bold" : "normal",
                width: "100%",
                padding: 4
              }}
            >
              {params.value.toFixed(3)}%
            </div>
          );
        }
      },

      {
        field: "abs_diferencia_unidades",
        headerName: "Dif.Abs.Un.(%)",
        flex: 1,
        minWidth: 170,
        valueFormatter: (params) =>
          `${params.value.toFixed(3)}%`
      },

      {
        field: "estado",
        headerName: "Estado",
        flex: 1,
        minWidth: 100,
        valueGetter: (params) =>
          params.row.estado
            ?.toLowerCase()
            .replace(/\b\w/g, (l) => l.toUpperCase())
      }
    ];

    return (
      <div style={{ height: '100%', width: "100%" }}>
        <DataGrid
          rows={this.props.disponibles}
          disableColumnMenu
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rowCount={this.props.total ?? 0}
          sortingOrder={['asc', 'desc']}
          sortingMode="server" 
          onSortModelChange={this.props.onSortChange} 
          paginationMode="server"
          paginationModel={this.props.paginationModel}          
          pageSizeOptions={[10, 25, 50]}
          onPaginationModelChange={this.props.onPageChange}
          onRowClick={(params) =>
            this.setState({ selectedRow: params.id })
          }
          getRowClassName={(params) => {
            if (this.state.selectedRow === params.id)
              return "row-selected";
            return "";
          }}
          getRowId={(row) => row.folio}
        />
  
        {this.state.openSnack && (
          <SnackbarAlert
            severity={this.state.severity}
            message={this.state.message}
          />
        )}

        <style>
          {`
            .row-selected { background-color: #dbe9fc !important; }
          `}
        </style>
      </div>
    );
  }
}

export default TablaPanelAuditorias;